document.addEventListener('DOMContentLoaded', function () {

  let facetsCounter = 0;
  function getContainerIndex(container) {
    if (!container.dataset.facetsIndex) {
      container.dataset.facetsIndex = String(facetsCounter++);
    }
    return container.dataset.facetsIndex;
  }

  function getAllFacetsContainers() {
    return Array.from(document.querySelectorAll('.facets'));
  }

  const DEBUG = window.location.search.includes('debug_filters=1');
  function debug(...args) {
    if (DEBUG) console.log('[custom-filters]', ...args);
  }

  function readJsonScript(id) {
    const el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent.trim());
    } catch (e) {
      return null;
    }
  }

  function applyCategoryTree(lvl1, lvl2, lvl3) {
    const tree = readJsonScript('CategoryTree');
    if (!tree || typeof tree !== 'object') {
      const meta = readJsonScript('CategoryProductMeta');
      if (!Array.isArray(meta)) return false;

      function asArray(value) {
        if (!value) return [];
        if (Array.isArray(value)) return value.map((v) => String(v)).filter(Boolean);
        return [String(value)];
      }

      const lvl1Set = new Set();
      const lvl2Set = new Set();
      const map12 = {};
      const map23 = {};
      meta.forEach((row) => {
        const l1s = asArray(row && row.lvl1);
        const l2s = asArray(row && row.lvl2);
        const l3s = asArray(row && row.lvl3);

        l1s.forEach((l1) => {
          lvl1Set.add(l1);
          if (!map12[l1]) map12[l1] = new Set();
          l2s.forEach((l2) => {
            if (l2) map12[l1].add(l2);
          });
        });

        l2s.forEach((l2) => {
          if (!l2) return;
          lvl2Set.add(l2);
          if (!map23[l2]) map23[l2] = new Set();
          l3s.forEach((l3) => {
            if (l3) map23[l2].add(l3);
          });
        });
      });

      const lvl1Options = Array.from(lvl1.querySelectorAll('input[type="checkbox"]'));
      lvl1Options.forEach((cb) => {
        const label = cb.value || cb.getAttribute('value') || '';
        const show = lvl1Set.has(label);
        const item = cb.closest('.facets__item');
        if (item) item.classList.toggle('hidden', !show);
      });

      const lvl2Options = Array.from(lvl2.querySelectorAll('input[type="checkbox"]'));
      lvl2Options.forEach((cb) => {
        const label = cb.value || cb.getAttribute('value') || '';
        const show = lvl2Set.has(label);
        const item = cb.closest('.facets__item');
        if (item) item.classList.toggle('hidden', !show);
      });

      const selectedLvl1 = lvl1Options.filter((cb) => cb.checked).map((cb) => cb.value);
      const allowedLvl2 = new Set();
      if (selectedLvl1.length > 0) {
        selectedLvl1.forEach((key) => {
          const list = map12[key];
          if (list) Array.from(list).forEach((v) => allowedLvl2.add(v));
        });
      }
      lvl2Options.forEach((cb) => {
        const label = cb.value || cb.getAttribute('value') || '';
        const show = selectedLvl1.length === 0 ? false : allowedLvl2.has(label);
        const item = cb.closest('.facets__item');
        if (item) item.classList.toggle('hidden', !show);
      });

      const selectedLvl2 = lvl2Options.filter((cb) => cb.checked).map((cb) => cb.value);
      const allowedLvl3 = new Set();
      if (selectedLvl2.length > 0) {
        selectedLvl2.forEach((key) => {
          const list = map23[key];
          if (list) Array.from(list).forEach((v) => allowedLvl3.add(v));
        });
      }

      const lvl3Options = Array.from(lvl3.querySelectorAll('input[type="checkbox"]'));
      lvl3Options.forEach((cb) => {
        const label = cb.value || cb.getAttribute('value') || '';
        const show = allowedLvl3.size === 0 ? false : allowedLvl3.has(label);
        const item = cb.closest('.facets__item');
        if (item) item.classList.toggle('hidden', !show);
      });

      return true;
    }

    const allowedLvl2 = new Set(Object.keys(tree));

    const lvl1Options = Array.from(lvl1.querySelectorAll('input[type="checkbox"]'));
    lvl1Options.forEach((cb) => {
      const label = cb.value || cb.getAttribute('value') || '';
      const show = Object.prototype.hasOwnProperty.call(tree, label);
      const item = cb.closest('.facets__item');
      if (item) item.classList.toggle('hidden', !show);
    });

    const lvl2Options = Array.from(lvl2.querySelectorAll('input[type="checkbox"]'));
    lvl2Options.forEach((cb) => {
      const label = cb.value || cb.getAttribute('value') || '';
      const show = allowedLvl2.has(label);
      const item = cb.closest('.facets__item');
      if (item) item.classList.toggle('hidden', !show);
    });

    const selectedLvl1 = lvl1Options.filter((cb) => cb.checked).map((cb) => cb.value);
    const allowedLvl2ByLvl1 = new Set();
    if (selectedLvl1.length > 0) {
      selectedLvl1.forEach((key) => {
        const list = tree[key];
        if (list && typeof list === 'object') {
          Object.keys(list).forEach((v) => allowedLvl2ByLvl1.add(v));
        }
      });
    }
    lvl2Options.forEach((cb) => {
      const label = cb.value || cb.getAttribute('value') || '';
      const show = selectedLvl1.length === 0 ? false : allowedLvl2ByLvl1.has(label);
      const item = cb.closest('.facets__item');
      if (item) item.classList.toggle('hidden', !show);
    });

    const selectedLvl2 = lvl2Options.filter((cb) => cb.checked).map((cb) => cb.value);
    const allowedLvl3 = new Set();
    if (selectedLvl2.length > 0) {
      selectedLvl2.forEach((key) => {
        selectedLvl1.forEach((parent) => {
          const list = tree[parent] && tree[parent][key];
          if (Array.isArray(list)) {
            list.forEach((v) => allowedLvl3.add(v));
          }
        });
      });
    }

    const lvl3Options = Array.from(lvl3.querySelectorAll('input[type="checkbox"]'));
    lvl3Options.forEach((cb) => {
      const label = cb.value || cb.getAttribute('value') || '';
      const show = allowedLvl3.size === 0 ? false : allowedLvl3.has(label);
      const item = cb.closest('.facets__item');
      if (item) item.classList.toggle('hidden', !show);
    });

    return true;
  }

  function groupCategoryFilters(container, lvl1, lvl2, lvl3) {
    const idx = getContainerIndex(container) || '0';
    const groupId = 'category-filters-group-' + idx;
    let group = container.querySelector('#' + groupId);
    if (!group) {
      group = document.createElement('details');
      group.id = groupId;
      group.className = 'facets__disclosure-vertical facets__group facets__group--category';
      group.open = true;

      const summary = document.createElement('summary');
      summary.className = 'facets__summary caption-large focus-offset';
      const summaryInner = document.createElement('div');
      const titleSpan = document.createElement('span');
      titleSpan.textContent = 'Catégories';
      summaryInner.appendChild(titleSpan);
      const caret = container.querySelector('.icon-caret');
      if (caret) summaryInner.appendChild(caret.cloneNode(true));
      summary.appendChild(summaryInner);
      group.appendChild(summary);

      const anchor = lvl1 || lvl2 || lvl3;
      if (!anchor || !anchor.parentNode) return;
      anchor.parentNode.insertBefore(group, anchor);
    }

    if (lvl1) lvl1.classList.add('facets__tree-level1');
    if (lvl2) lvl2.classList.add('facets__tree-level2');
    if (lvl3) lvl3.classList.add('facets__tree-level3');

    [lvl1, lvl2, lvl3].forEach((el) => {
      if (el && el.parentNode !== group) group.appendChild(el);
      if (el) {
        el.open = true;
        const summary = el.querySelector('summary');
        if (summary) summary.classList.add('visually-hidden');
      }
    });

    // Safety: ensure only category filters are inside the group
    group.querySelectorAll('details').forEach((detail) => {
      const id = detail.id || '';
      const isCategory =
        id.includes('custom.categorie_level_1') || id.includes('custom.categorie_level_2') || id.includes('custom.categorie_level_3');
      if (!isCategory && detail !== group) {
        group.parentNode.insertBefore(detail, group.nextSibling);
      }
    });
  }

  // Fonction pour initialiser/mettre à jour les filtres
  function initFilters(container) {
    getContainerIndex(container);

    // Notre sidebar custom (dv-facets) gère le show/hide côté Liquid — pas de JS nécessaire
    if (container.querySelector('.dv-facets')) {
      debug('dv-facets container — skipping JS tree logic');
      return false;
    }

    const lvl1 = container.querySelector('details[id*="custom.categorie_level_1"]');
    const lvl2 = container.querySelector('details[id*="custom.categorie_level_2"]');
    const lvl3 = container.querySelector('details[id*="custom.categorie_level_3"]');

    if (!lvl2) {
      debug('missing levels', {
        container: container.dataset.facetsIndex,
        lvl1: !!lvl1,
        lvl2: !!lvl2,
        lvl3: !!lvl3
      });
      return false; // lvl2 minimum requis
    }

    groupCategoryFilters(container, lvl1, lvl2, lvl3);
    debug('grouped', { container: container.dataset.facetsIndex });

    // Masquer lvl2 et lvl3 au départ
    lvl2.style.setProperty('display', 'none', 'important');
    if (lvl3) lvl3.style.setProperty('display', 'none', 'important');

    // Fonction pour mettre à jour la visibilité
    function setLvl3EmptyState(show, hasItems) {
      let empty = lvl3.querySelector('.facets__level3-empty');
      if (empty) empty.remove();
    }

    function countVisibleItems(level) {
      return Array.from(level.querySelectorAll('.facets__item')).filter((el) => !el.classList.contains('hidden')).length;
    }

    function hideAllItems(level) {
      Array.from(level.querySelectorAll('.facets__item')).forEach((el) => el.classList.add('hidden'));
    }

    function getFilterParams() {
      try {
        return new URLSearchParams(window.location.search);
      } catch (e) {
        return null;
      }
    }

    function hasActiveParam(params, ...keys) {
      return keys.some((k) => params.has(k) && params.getAll(k).some((v) => v && v.length > 0));
    }

    function enforceDisplayFromParams() {
      const params = getFilterParams();
      if (!params) return;
      const lvl1Active = hasActiveParam(params,
        'filter.p.m.custom.categorie_level_1',
        'filter.p.m.custom.categorie_level_11'
      );
      const lvl2Active = hasActiveParam(params,
        'filter.p.m.custom.categorie_level_2',
        'filter.p.m.custom.categorie_level_21'
      );
      lvl2.style.setProperty('display', lvl1Active ? 'block' : 'none', 'important');
      if (lvl3) lvl3.style.setProperty('display', lvl2Active ? 'block' : 'none', 'important');
    }

    function updateVisibility() {
      const params = getFilterParams();
      const lvl1Active = params ? hasActiveParam(params,
        'filter.p.m.custom.categorie_level_1',
        'filter.p.m.custom.categorie_level_11'
      ) : false;
      const lvl2Active = params ? hasActiveParam(params,
        'filter.p.m.custom.categorie_level_2',
        'filter.p.m.custom.categorie_level_21'
      ) : false;
      const lvl3Active = params ? hasActiveParam(params,
        'filter.p.m.custom.categorie_level_3',
        'filter.p.m.custom.categorie_level_31'
      ) : false;
      const hasAnyFilterParam = lvl1Active || lvl2Active || lvl3Active;
      const hasAnyChecked =
        (lvl1 ? Array.from(lvl1.querySelectorAll('input[type="checkbox"]')).some((cb) => cb.checked) : false) ||
        Array.from(lvl2.querySelectorAll('input[type="checkbox"]')).some((cb) => cb.checked) ||
        (lvl3 ? Array.from(lvl3.querySelectorAll('input[type="checkbox"]')).some((cb) => cb.checked) : false);

      // Keep user click state before URL params are updated by Shopify AJAX.
      if (!hasAnyFilterParam && !hasAnyChecked) {
        [lvl1, lvl2, lvl3].filter(Boolean).forEach((level) => {
          level.querySelectorAll('input[type="checkbox"]').forEach((cb) => (cb.checked = false));
        });
      }
      const hasTree = applyCategoryTree(lvl1, lvl2, lvl3);
      if (hasTree) {
        const lvl1Checked =
          lvl1Active ||
          (lvl1 ? Array.from(lvl1.querySelectorAll('input[type="checkbox"]')).some((cb) => cb.checked) : false);
        lvl2.style.setProperty('display', lvl1Checked ? 'block' : 'none', 'important');
        if (!lvl1Checked) {
          hideAllItems(lvl2);
          if (lvl3) hideAllItems(lvl3);
          lvl2.querySelectorAll('input[type="checkbox"]').forEach((cb) => (cb.checked = false));
          if (lvl3) {
            lvl3.style.setProperty('display', 'none', 'important');
            lvl3.querySelectorAll('input[type="checkbox"]').forEach((cb) => (cb.checked = false));
          }
          setLvl3EmptyState(false, false);
          return;
        }
        lvl2.style.setProperty('display', 'block', 'important');
        const lvl2Checked =
          lvl2Active ||
          Array.from(lvl2.querySelectorAll('input[type="checkbox"]')).some((cb) => cb.checked);
        if (lvl3) lvl3.style.setProperty('display', lvl2Checked ? 'block' : 'none', 'important');
        if (!lvl2Checked) {
          if (lvl3) {
            hideAllItems(lvl3);
            lvl3.querySelectorAll('input[type="checkbox"]').forEach((cb) => (cb.checked = false));
          }
          setLvl3EmptyState(false, false);
        } else {
          setLvl3EmptyState(true, lvl3 ? countVisibleItems(lvl3) > 0 : false);
        }
      } else {
        const lvl1Checked =
          lvl1Active ||
          (lvl1 ? Array.from(lvl1.querySelectorAll('input[type="checkbox"]')).some((cb) => cb.checked) : false);
        lvl2.style.setProperty('display', lvl1Checked ? 'block' : 'none', 'important');
        if (!lvl1Checked) {
          hideAllItems(lvl2);
          if (lvl3) hideAllItems(lvl3);
          lvl2.querySelectorAll('input[type="checkbox"]').forEach((cb) => (cb.checked = false));
          if (lvl3) {
            lvl3.style.setProperty('display', 'none', 'important');
            lvl3.querySelectorAll('input[type="checkbox"]').forEach((cb) => (cb.checked = false));
          }
          setLvl3EmptyState(false, false);
          return;
        }
        const lvl2Checked =
          lvl2Active ||
          Array.from(lvl2.querySelectorAll('input[type="checkbox"]')).some((cb) => cb.checked);
        if (lvl3) lvl3.style.setProperty('display', lvl2Checked ? 'block' : 'none', 'important');
        if (!lvl2Checked) {
          if (lvl3) {
            hideAllItems(lvl3);
            lvl3.querySelectorAll('input[type="checkbox"]').forEach((cb) => (cb.checked = false));
          }
          setLvl3EmptyState(false, false);
        } else {
          setLvl3EmptyState(true, lvl3 ? countVisibleItems(lvl3) > 0 : false);
        }
      }

      // Final override from URL params (Shopify can reset styles)
      enforceDisplayFromParams();
    }

    // Ajouter écouteurs sur toutes les checkboxes lvl1 et lvl2
    [lvl1, lvl2].filter(Boolean).forEach(level => {
      level.querySelectorAll('input[type="checkbox"]').forEach(cb => {
        cb.removeEventListener('change', updateVisibility); // éviter double écouteur
        cb.addEventListener('change', updateVisibility);
      });
    });

    // Appliquer état initial
    updateVisibility();
    enforceDisplayFromParams();
    // Re-check shortly after in case Shopify rehydrates facets after AJAX/back
    setTimeout(() => {
      updateVisibility();
      enforceDisplayFromParams();
    }, 50);
    setTimeout(() => {
      updateVisibility();
      enforceDisplayFromParams();
    }, 200);
    setTimeout(() => {
      updateVisibility();
      enforceDisplayFromParams();
    }, 500);

    // Watch for external toggles on lvl3 display
    const displayObserver = new MutationObserver(() => {
      enforceDisplayFromParams();
    });
    displayObserver.observe(lvl2, { attributes: true, attributeFilter: ['style', 'class'] });
    if (lvl3) displayObserver.observe(lvl3, { attributes: true, attributeFilter: ['style', 'class'] });

    return true; // initialisation réussie
  }

  let refreshTimer = null;
  let isRefreshing = false;
  function scheduleRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => {
      if (isRefreshing) return;
      isRefreshing = true;
      try {
        getAllFacetsContainers().forEach((container) => initFilters(container));
      } finally {
        isRefreshing = false;
      }
    }, 30);
  }

  // Re-run when Shopify updates filters via AJAX without adding a new page
  const observer = new MutationObserver((mutations) => {
    let shouldRefresh = false;
    mutations.forEach((m) => {
      if (shouldRefresh) return;
      const target = m.target && m.target.nodeType === 1 ? m.target : null;
      if (target && target.closest && target.closest('.facets')) {
        shouldRefresh = true;
        return;
      }
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach((node) => {
          if (shouldRefresh || node.nodeType !== 1) return;
          if (node.matches && (node.matches('.facets') || node.matches('details[id*="custom.categorie_"]'))) {
            shouldRefresh = true;
            return;
          }
          if (node.querySelector && (node.querySelector('.facets') || node.querySelector('details[id*="custom.categorie_"]'))) {
            shouldRefresh = true;
          }
        });
      }
    });
    if (shouldRefresh) scheduleRefresh();
  });

  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'open'] });

  // Initial run
  getAllFacetsContainers().forEach((container) => initFilters(container));

  // Handle back/forward cache
  window.addEventListener('pageshow', () => {
    getAllFacetsContainers().forEach((container) => initFilters(container));
  });

  // Re-apply after Shopify facet updates
  document.addEventListener('facet:updated', () => {
    getAllFacetsContainers().forEach((container) => initFilters(container));
  });

  // Immediate response on click before/while Shopify refreshes the section
  document.addEventListener('change', (event) => {
    document.dispatchEvent(new Event("BSS:changeVariantQV"));
    const target = event.target;
    if (!target || !target.matches || !target.matches('input[type="checkbox"]')) return;
    const name = target.name || '';
    if (!name.includes('filter.p.m.custom.categorie_level_1') && !name.includes('filter.p.m.custom.categorie_level_2')) return;
    scheduleRefresh();
  });

});
